export default __webpack_public_path__ + "static/media/JNKVV-Logo.21756e4a.png";